import { trigger, transition, style, query, animate, keyframes } from '@angular/animations'

export const slideAnimations = [
  trigger('slideContainer', [
    transition('list => form', [
      query(
        ':leave',
        [
          style({ transform: 'translateX(0)', opacity: 1, display: 'block' }),
          animate('400ms ease-in', style({ transform: 'translateX(-100%)', opacity: 0, display: 'none' })),
        ],
        { optional: true }
      ),

      query(
        ':enter',
        [
          animate(
            '400ms ease-out',
            keyframes([
              style({ offset: 0, transform: 'translateX(100%)', opacity: 0, display: 'none' }),
              style({ offset: 0.2, transform: 'translateX(80%)', opacity: 0.1, display: 'block' }),
              style({ offset: 1, transform: 'translateX(0)', opacity: 1, display: 'block' }),
            ])
          ),
        ],
        { optional: true }
      ),
    ]),

    transition('form => list', [
      query(
        ':leave',
        [
          style({ transform: 'translateX(0)', opacity: 1, display: 'block' }),
          animate('400ms ease-in', style({ transform: 'translateX(100%)', opacity: 0, display: 'none' })),
        ],
        { optional: true }
      ),

      query(
        ':enter',
        [
          animate(
            '400ms ease-out',
            keyframes([
              style({ offset: 0, transform: 'translateX(-100%)', opacity: 0, display: 'none' }),
              style({ offset: 0.2, transform: 'translateX(-80%)', opacity: 0.1, display: 'block' }),
              style({ offset: 1, transform: 'translateX(0)', opacity: 1, display: 'block' }),
            ])
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
]
